module.exports = __webpack_public_path__ + "img/md.dfc9b81a.png";